import { createRouter ,createWebHashHistory } from 'vue-router'
import work from "@/router/work"   //退款管理
import statistic from "@/router/statistic"   //退款管理
import { ElMessage } from 'element-plus'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component: () => import('@/pages/main/main'),
            meta: {
                title: '自述文件'
            },
            redirect: '/home',
            children: [
                {
                    path: "/home",
                    component: () => import("@/pages/main/home"),
                    meta: {
                        title: "首页"
                    },
                },
                work,
                statistic,
            ]
        },
        {
            path: '/login',
            component: () => import('@/pages/main/login'),
            meta: {
                title: '登陆'
            },
        },
    ],
})
//判断是否登录
router.beforeEach(async (to,from,next) => {
    //如果不是登陆页面并且没有用户信息则跳转到登陆页
    if (to.path !== "/login"&&localStorage.getItem("userInfo") === null){
        ElMessage.error('信息过期,请重新登陆')
        next('/login')
    }else {
        next()
    }
});

export default router
